import { ReactNode } from 'react';

import { ScrollbarTheme } from 'components/horizontal-scroller/horizontal-scroller';

export interface IResponsiveCarouselProps {
  children: ReactNode[];
  bgColor?: string;
  scrollbarTheme?: ScrollbarTheme;
  centerCards?: boolean;
  alignWithParent?: boolean;
  hideScrollBar?: boolean;
}

export interface ISideButtonWrappedProps {
  isMobile: boolean;
  bgColor: string;
  isOverflow: boolean;
}

export enum Sizes {
  SPACER = 8,
}
